import React, { FC } from "react";
import { Toolbar, ToolbarProps } from "@mui/material"

const ToolbarWrapper: FC<ToolbarProps> = ({...props}) => <Toolbar {...props}/>

export default ToolbarWrapper;